import $ from 'jquery';

if( $( "html" ).attr("dir") == "rtl" ) {
	var rtl = true;
} else {
	var rtl = false;
}


$( '.js-hero-slider' ).slick( {
	rtl: rtl,
	dots: true,
	rows: false,
	responsive: [
		{
			breakpoint: 992,
			settings: {
				adaptiveHeight: true,
			}
		},
		{
			breakpoint: 768,
			settings: {
				adaptiveHeight: true,
				arrows: false,
			}
		}
	],
} );
